
import { v4 as uuidv4 } from 'uuid';

const ANALYTICS_SESSION_KEY = 'obvio_analytics_session_id';

/**
 * Get or create a persistent session ID for analytics
 */
export const getAnalyticsSessionId = () => {
    if (typeof window === 'undefined') return '';

    let sessionId = localStorage.getItem(ANALYTICS_SESSION_KEY);
    if (!sessionId) {
        sessionId = uuidv4();
        if (sessionId) {
            localStorage.setItem(ANALYTICS_SESSION_KEY, sessionId);
        }
    }
    return sessionId || '';
};

/**
 * Track an event to the backend
 */
export const trackEvent = async (type: string, metadata: any = {}) => {
    try {
        const sessionId = getAnalyticsSessionId();
        const url = typeof window !== 'undefined' ? window.location.href : '';

        console.log(`[Analytics] Tracking ${type}...`);

        // We use a relative path because we have re-writes in next.config.js
        // Renamed to /collect to avoid ad-blockers that trigger on "tracking" or "analytics"
        const res = await fetch('/api/v1/collect', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type,
                sessionId,
                url,
                metadata
            })
        });

        if (!res.ok) {
            console.warn('[Analytics] Failed to track event:', type, res.status);
        } else {
            console.log(`[Analytics] Successfully tracked ${type}`);
        }
    } catch (e) {
        console.error('[Analytics] Tracking error:', e);
    }
};

/**
 * Track a pageview
 */
export const trackPageView = (url: string) => {
    trackEvent('pageview', { path: url });
};

/**
 * Analytics Hook/Monitor
 */
export const initAnalytics = () => {
    if (typeof window === 'undefined') return;

    // Track initial page load
    trackPageView(window.location.pathname);

    // Track heartbeats every 30s to measure session duration / bounce
    setInterval(() => {
        trackEvent('heartbeat');
    }, 30000);
};
